import { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';
import SuggestedUser from './SuggestedUser';

function RightSidebar({ suggestedUsers }) {
  const { user } = useContext(AuthContext);

  // Get display info for current user
  const currentUsername = user?.email?.split('@')[0] || 'demo_user';
  const currentInitials = currentUsername.slice(0, 2).toUpperCase();

  return (
    <aside className="hidden lg:block w-right-sidebar ml-8 pt-8 flex-shrink-0">
      {/* Current user card */}
      <div className="flex items-center gap-4 mb-6">
        <Link to="/profile/demo_user" className="flex-shrink-0">
          <div className="w-14 h-14 rounded-full bg-gray-200 flex items-center justify-center">
            <span className="text-lg font-semibold text-gray-500">
              {currentInitials}
            </span>
          </div>
        </Link>
        <div className="min-w-0">
          <Link to="/profile/demo_user" className="font-semibold text-sm text-puzzle-text block truncate hover:underline">
            {currentUsername}
          </Link>
          <p className="text-puzzle-text-secondary text-sm truncate">
            {user?.email || 'Guest User'}
          </p>
        </div>
        {!user && (
          <Link
            to="/login"
            className="text-puzzle-blue text-xs font-semibold ml-auto"
          >
            Log in
          </Link>
        )}
      </div>

      {/* Suggestions header */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-puzzle-text-secondary font-semibold text-sm">
          Suggested For You
        </span>
        <button
          type="button"
          className="text-xs font-semibold text-puzzle-text hover:opacity-70 transition-opacity"
        >
          See All
        </button>
      </div>

      {/* Suggested users list */}
      <div className="space-y-1">
        {suggestedUsers.map((suggestedUser) => (
          <SuggestedUser key={suggestedUser.id} user={suggestedUser} />
        ))}
      </div>

      {/* Footer links */}
      <div className="mt-6 text-xs text-puzzle-text-secondary">
        <div className="flex flex-wrap gap-x-1 gap-y-0.5">
          <span>About</span>
          <span>·</span>
          <span>Help</span>
          <span>·</span>
          <span>Press</span>
          <span>·</span>
          <span>API</span>
          <span>·</span>
          <span>Jobs</span>
          <span>·</span>
          <span>Privacy</span>
          <span>·</span>
          <span>Terms</span>
        </div>
        <p className="mt-4">© 2025 Picture Puzzle</p>
      </div>
    </aside>
  );
}

RightSidebar.propTypes = {
  suggestedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string,
      relation: PropTypes.string,
    }),
  ),
};

RightSidebar.defaultProps = {
  suggestedUsers: [],
};

export default RightSidebar;
